import classNames from 'classnames';

import { Component, Element, h, Host, Prop, State } from '@stencil/core';

@Component({
  tag: 'pn-spotlight',
  styleUrl: 'pn-spotlight.scss',
})
export class PnSpotlight {
  @Element() hostElement: HTMLElement;
  @Prop() heading: string = null;
  @Prop() preamble: string = null;
  @Prop() isDynamic: boolean = false;

  @State() addDynamic: string = '';

  componentDidLoad() {
    this.addDynamic = classNames({ 'cta--dynamic': this.isDynamic });
  }

  render() {
    return (
      <Host>
        <div class="pn-spotlight__container">
          <slot name="mobile-heading" />
          <div class={`pn-spotlight__container__wrapper ${this.addDynamic}`}>
            <div class="pn-spotlight__container__wrapper__content">
              <div class="pn-spotlight__container__wrapper__content__ball"></div>
              <slot name="content" />
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
